// extracted by mini-css-extract-plugin
module.exports = {"stage":"Stage_stage__3LaHX","body":"Stage_body__2Siv6","header":"Stage_header__30DrV"};